// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "ul.ztree.zTreeDragUL{margin:0;padding:0;position:absolute;overflow:hidden;background-color:#dedede;border:1px dotted #4fcbf0;border-radius:4px;opacity:.7}.zTreeMask{position:absolute;z-index:10000;opacity:0;background-color:#cfcfcf}", ""]);
// Exports
module.exports = exports;
